import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { fetchPropertySuites, clearSuites } from '../../store/actions/suites';
import { fetchSuiteAssets, clearAssets } from '../../store/actions/assets';
import { fetchProperties } from '../../store/actions/properties';
import { fetchSuiteById } from '../../store/actions/suites';
import {
  selectProperties,
  selectPropertyById,
} from '../../store/selectors/properties';
import { selectSuites } from '../../store/selectors/suites';
import { selectServiceRequestFormData } from '../../store/selectors/serviceRequestForm';
import { selectSuiteById } from '../../store/selectors/suites';
import {
  setServiceRequestFormData,
  setServiceRequestFormNextStep,
  setServiceRequestFormStep,
  exitServiceRequestForm,
} from '../../store/actions/serviceRequestForm';
import Button from '../Button';
import Col from '../Col';
import Form from '../Form';
import Row from '../Row';
import Select from '../Select';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { fetchAllIssueTypes } from '../../store/actions/formOptions';
import Tile from '../Tile';
import { variables } from '../../Tenants';
import './ServiceRequestFormSuite.scss';

class ServiceRequestFormSuite extends Component {
  loadProperties() {
    const { onFetchProperties, user } = this.props;
    onFetchProperties(user.id, user.roles[0].role.name);
  }

  loadSuites() {
    const { onFetchPropertySuites, serviceRequestFormData, user } = this.props;
    if (serviceRequestFormData.property_id) {
      onFetchPropertySuites(
        serviceRequestFormData.property_id,
        user.id,
        user.roles[0].role.name
      );
    }
  }

  loadSuite() {
    const { onFetchSuiteById, serviceRequestFormData } = this.props;
    if (serviceRequestFormData.suite_id) {
      onFetchSuiteById(serviceRequestFormData.suite_id);
    }
  }

  componentDidMount() {
    this.loadProperties();
    this.loadSuites();
    this.loadSuite();
    this.props.onFetchIssueTypes();
    if (
      this.props.serviceRequestFormData &&
      this.props.serviceRequestFormData.serviceRequestType
    ) {
    } else {
      this.props.onSetServiceRequestFormData({
        serviceRequestType: 'Suite',
      });
    }
    const { from, onSetServiceRequestFormData, propertyData } = this.props;
    if (from === 'HomeOwnerDashboard') {
      onSetServiceRequestFormData({
        property_id: propertyData.propertyid,
        propertyId: propertyData.propertyId,
        suiteId: propertyData.suiteId,
        suite_id: propertyData.suite_id,
        serviceRequestType: 'Suite',
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      serviceRequestFormData,
      onFetchPropertySuites,
      onFetchSuiteById,
      user,
    } = this.props;

    if (
      prevProps.serviceRequestFormData.property_id !==
      serviceRequestFormData.property_id
    ) {
      onFetchPropertySuites(
        serviceRequestFormData.property_id,
        user.id,
        user.roles[0].role.name
      );
    }

    if (
      prevProps.serviceRequestFormData.suiteId !==
      serviceRequestFormData.suite_id
    ) {
      onFetchSuiteById(serviceRequestFormData.suite_id);
    }
  }

  handleOnChangeProperty(e) {
    const {
      onSetServiceRequestFormData,
      onClearFetchedSuites,
      onClearFetchedAssets,
      serviceRequestFormData,
    } = this.props;
    if (
      serviceRequestFormData.suiteId &&
      serviceRequestFormData.suiteId !== ''
    ) {
      onSetServiceRequestFormData({
        property_id: e.target.value,
        propertyId: e.target.value,
        suite_id: '',
        suiteId: '',
        serviceRequestType: 'Suite',
        asset_item_id: '',
        asset_item_nameDescription: '',
        assetId: '',
      });
    } else {
      onSetServiceRequestFormData({
        property_id: e.target.value,
        propertyId: e.target.value,
        serviceRequestType: 'Suite',
        asset_item_id: '',
        asset_item_nameDescription: '',
        assetId: '',
      });
    }

    onClearFetchedSuites();
    onClearFetchedAssets();
  }

  handleOnChangeSuite(e) {
    const { onSetServiceRequestFormData, onfetchAssetsBySuiteId, suites } =
      this.props;
    onSetServiceRequestFormData({
      suite_id: e.target.value,
      suiteId: e.target.value,
      suiteFloorPLan: suites.filter((data) => data.id === e.target.value)[0]
        .floorPlanURL,
      annotatateImage: false,
      asset_item_id: '',
      asset_item_nameDescription: '',
      assetId: '',
    });
    onfetchAssetsBySuiteId(e.target.value);
  }

  handleNext() {
    const {
      onSetServiceRequestFormNextStep,
      onSetServiceRequestFormData,
      user,
    } = this.props;
    onSetServiceRequestFormData({
      creatorId: user.id,
    });
    onSetServiceRequestFormNextStep();
  }

  render() {
    const {
      properties,
      property,
      suites,
      suite,
      serviceRequestFormData,
      onExitServiceRequestForm,
      onClose,
      onExit,
      user,
    } = this.props;
    const role = user.roles[0].role.name;
    return (
      <Form
        headline={`Start Your ${variables.serviceRequest}`}
        strapline="First, tell us which unit this request is for."
        onClose={() => {
          onExitServiceRequestForm();
          if (onClose) onClose();
        }}
        onExit={() => {
          onExitServiceRequestForm();
          if (onExit) onExit();
        }}
        component={
          <Row mdCenter>
            <Col xs="12" md="6">
              <Select
                value={serviceRequestFormData.property_id}
                label="Property"
                placeholder="(Select Property) "
                onChange={(e) => this.handleOnChangeProperty(e)}
                options={properties.map((property) => ({
                  label: property.name,
                  value: property.id,
                }))}
                disabled={
                  this.props.propertyDisabled
                    ? this.props.propertyDisabled
                    : false
                }
              />
              <Select
                value={serviceRequestFormData.suite_id}
                label={variables.Suite}
                placeholder={`(Select ${variables.Suite})`}
                onChange={(e) => this.handleOnChangeSuite(e)}
                options={
                  serviceRequestFormData.property_id
                    ? suites.map((suite) => ({
                        label: suite.number,
                        value: suite.id,
                      }))
                    : []
                }
              />

              <div
                className="serviceRequestFormSuite"
                style={{ marginBottom: '100px;' }}
              >
                <div
                  className="serviceRequestFormSuite__image"
                  style={{
                    backgroundImage: `url(${property ? property.image : ''})`,
                  }}
                />
                <div className="serviceRequestFormSuite__address">
                  {property ? (
                    <>
                      <div className="serviceRequestFormSuite__title">
                        {property.name} {suite ? ' / ' + suite.number : ''}
                      </div>
                      {property.addressLine1}
                      <br />
                      {property.city}, {property.province}
                      <br />
                      {property.postalCode}
                    </>
                  ) : (
                    <>
                      <div className="serviceRequestFormSuite__title">
                        Property / Suite
                      </div>
                      Street Address
                      <br />
                      City, Province
                      <br />
                      Postal Code
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        }
        footer={
          <div
            style={{
              position: 'fixed',
              bottom: '0',
              left: '0',
              width: '100%',
              background: '#fff',
              padding: '15px',
              boxShadow: '0 0 0.3rem rgba(0, 0, 0, 0.3)',
            }}
          >
            <Button
              color="teal"
              size="small"
              label="Next: Select Room / Item"
              onClick={() => this.handleNext()}
              disabled={
                !serviceRequestFormData.property_id
              }
            />
          </div>
        }
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const serviceRequestFormData = selectServiceRequestFormData(state);

  return {
    properties: selectProperties(state),
    property: selectPropertyById(state, serviceRequestFormData.property_id),
    suites: selectSuites(state),
    suite: selectSuiteById(state, serviceRequestFormData.suite_id),
    serviceRequestFormData: selectServiceRequestFormData(state),
    user: selectAuthenticatedUser(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchProperties: fetchProperties,
      onFetchPropertySuites: fetchPropertySuites,
      onClearFetchedSuites: clearSuites,
      onClearFetchedAssets: clearAssets,
      onFetchSuiteById: fetchSuiteById,
      onfetchAssetsBySuiteId: fetchSuiteAssets,
      onSetServiceRequestFormData: setServiceRequestFormData,
      onSetServiceRequestFormNextStep: setServiceRequestFormNextStep,
      onSetServiceRequestFormStep: setServiceRequestFormStep,
      onExitServiceRequestForm: exitServiceRequestForm,
      onFetchIssueTypes: fetchAllIssueTypes,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceRequestFormSuite);
